import type React from 'react';

import { Text } from '@change/ds-core-ui';

import { parseHtml } from '@change-corgi/core-react/html';

import { BannerWrapper } from '#src/app/shared/components/banners/layout';

type Props = {
	message: string;
};

export const MaintenanceBanner: React.FC<Props> = ({ message }) => {
	return (
		<BannerWrapper className="py-1">
			<Text as="div" size="small">
				{parseHtml(message)}
			</Text>
		</BannerWrapper>
	);
};
